import { defineMessages } from 'react-intl';

export default defineMessages({
    thisPropertyBelongsToYou: {
        id: "wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.thisPropertyBelongsToYou",
        defaultMessage: "This property belongs to you?"
    },
    damageDescription: {
        id: 'wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.damageDescription',
        defaultMessage: 'Damage Description'
    },
    Yes: {
        id: 'wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.No',
        defaultMessage: 'No'
    },
    addNewLocation: {
        id: 'wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.addNewLocation',
        defaultMessage: 'Add new location'
    },
    cancel: {
        id: 'wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'wni.fnol.ho.views.incidentdetails.singlePropertyIncidentPopup.save',
        defaultMessage: 'Save'
    }
})